export const popoverZIndex = "z-[200]";
export const selectZIndex = "z-[200]";

export const fadeInModelZIndex = "z-[100]";
export const slideInDrawerNormalZIndex = "z-10";
export const slideInDrawerZIndex = "z-[150]";
export const slideInDrawerUnderlayZIndex = "z-[140]";
export const errorDialogJPZIndex = "z-[160]";

export const ctaZIndex = "z-[120]";
